module.exports = __webpack_public_path__ + "img/Resume-pic1@2x.ce2fc71b.webp";